// src/hooks/useUser.js
import { getData, postData, updateData, deleteData } from "../services/apiService";

export const fetchStats = () => getData("/admin-stats");
